import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { searchCatalogue, getCatalogueStatus } from "../lib/catalogueApi";
import { setPagedHead } from "./Paging";
import { StoreLayout } from "./StoreLayout";
import { useListing } from "./listing/useListing";
import { ListingView } from "./listing/ListingView";
import { WeakMatch } from "./ZeroResults";
import { ZeroResults } from "./ZeroResults";

// /products (All Products) and /search?q= share this page and the one filter system
export default function SearchPage() {
  const all = useLocation().pathname === "/products";
  const L = useListing((params) => searchCatalogue(params));
  const q = L.sp.get("q") || "";
  const [catalogueEmpty, setCatalogueEmpty] = useState(false);
  useEffect(() => { getCatalogueStatus().then((s) => setCatalogueEmpty(!!s.catalogue_empty)).catch(() => {}); }, []);
  useEffect(() => {
    document.title = `${q ? `Search: ${q}` : all ? "All products" : "Search"} - Rhyte Step IT`;
    setPagedHead(window.location.pathname + (q ? `?q=${encodeURIComponent(q)}` : ""), Number(L.sp.get("page") || 1), L.data?.total_pages || 1, "noindex,follow");
  }, [q, all, L.sp, L.data]);
  const empty = catalogueEmpty ? (
    <div className="mt-2" data-testid="catalogue-empty-banner"><div className="font-extrabold text-[var(--brand-primary)]">Catalogue update in progress</div><div className="text-slate-500">New products landing shortly.</div></div>
  ) : q ? <ZeroResults q={q} /> : null;
  return (
    <StoreLayout>
      <div className="mx-auto max-w-6xl px-5 py-8">
        <ListingView L={L} prefix="search" title={q ? `Results for “${q}”` : "All products"} baseLabel="All categories" emptyBody={empty} notice={(d) => (q && d.match?.low ? <WeakMatch q={q} /> : null)}
          crumbs={<nav className="mb-2 text-sm text-slate-500" aria-label="Breadcrumb"><Link to="/" className="hover:text-[var(--brand-link)]">Home</Link> / {q ? "Search" : "All products"}</nav>} />
      </div>
    </StoreLayout>
  );
}
